<template>
    <section class="bg-light page-section" id="services">
    <div class="container">
      <div class="row">
        
        
      
        
      
    
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:#ea1e29">Activities & News</h2>
          <h3 class="section-subheading text-muted">Keep upto date with what we are doing.</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-6"  v-for="(obj,key) in serviceJSON" :key="key">
        <!-- <span  class="col-md-4">
          <span class="fa-stack fa-4x">
            <i  class="fas fa-circle fa-stack-2x text-primary"></i>
            <i class="fas fa-lock fa-stack-1x fa-inverse"></i>
          </span>
          <h4 class="service-heading">{{obj.serviceTitle}}</h4>
          <p class="text-muted">{{obj.serviceText}}</p>
        </span> -->
        <v-card dark raised
    class="mx-auto"
    max-width="800"
    style="padding:10px;"
  >
    <v-img
      class="white--text align-end"
      height="200px"
      :src="obj.serviceImg"
    >
      
    </v-img>
<v-card-title>{{obj.serviceTitle}}</v-card-title>
    <v-card-subtitle class="pb-0">{{obj.serviceText}}</v-card-subtitle>

    <v-card-text >
      

      {{obj.serviceDate}}
    </v-card-text>

    <v-card-actions>
      <v-divider></v-divider><v-btn
        style="background-color:#ea1e29"
       fab
        :href=obj.serviceLink target="_blank"
      >
        <i class="fas fa-arrow-right"></i>
      </v-btn>

      
    </v-card-actions>
  </v-card>
        </div>
      </div>
    
    </div>
    
  </section>
  
</template>
<script>
export default {
    data:()=>(
      {
      serviceJSON:[{
        serviceTitle:"LuLu group International",
        serviceText:"If you would like to know more information about our family. Head over to the official website of our parent company.",
        serviceLink:"https://www.lulugroupinternational.com/",
        serviceImg:require('../assets/img/lulu.jpg'),
        serviceDate:""
      },{
        serviceTitle:"Gulf foods expo",
        serviceText:"We are excited to announce that we will be attending the 2021 Gulf food expo! See you there. ",
        serviceImg:require('../assets/img/gulffood.jpg'),
        serviceLink:"https://www.gulfood.com/",
        serviceDate:"Date :21-25 Feb 2021"
      },{
        serviceTitle:"Forbes ME: M.A. Yusuff Ali",
        serviceText:"Hailing from a village in Kerala state in south India, Yusuff Ali left for Abu Dhabi in 1973 to join his uncle's small distribution business...",
        serviceLink:"https://www.forbes.com/profile/ma-yusuff-ali/#70f0a884b26e",
        serviceImg:require('../assets/img/yusuf.png'),
        serviceDate:""
      },],
      isActive:false
    })
}
</script>
<style scoped>

</style>